import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicWallet({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M9.5 1.36c.52-.33 1.2-.2 1.55.3l2.03 2.84h.42c.97 0 1.75.78 1.75 1.75v7.5c0 .97-.78 1.75-1.75 1.75H3c-.97 0-1.75-.78-1.75-1.75v-7.5c0-.97.78-1.75 1.75-1.75h1.56zm4 4.64H3a.25.25 0 00-.25.25v7.5c0 .14.11.25.25.25h10.5c.14 0 .25-.11.25-.25v-7.5A.25.25 0 0013.5 6zM11 9a1 1 0 110 2 1 1 0 010-2zm-.92-6.47L6.98 4.5h4.5l-1.4-1.97zM7.4.1a.65.65 0 01.68 1.1l-4 2.5a.65.65 0 11-.68-1.1z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicWallet.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicWallet.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicWallet svgRef={ref} {...props} />);
export default ForwardRef;
